<template>
  <section :id="id" class="statement">
    <!-- <BackLink /> -->
    <h1 id="stepTitle" v-if="titleVisible">{{ title }}</h1>
    <div id="bodyContent" v-html="bodyContent"></div>

    <div v-if="topSections != null && topSections.length != 0">
    <div
        v-for="(item, itemIdx) in topSections"
        :key="'topSection-' + itemIdx"
    >
        <Accordion :isOpenOnLoad="item.openOnLoad">
          <template v-slot:title>{{ item.title }}</template>
          <template v-slot:content><span v-html="item.body"></span></template>
        </Accordion>
      </div>
    </div>

    <article>
      <Form @submit="submitStatement"></Form>
    </article>

    <div v-if="bottomSections != null && bottomSections.length != 0">
    <div
        v-for="(item, itemIdx) in bottomSections"
        :key="'bottomSection-' + itemIdx"
    >
        <Accordion :isOpenOnLoad="item.openOnLoad">
          <template v-slot:title>{{ item.title }}</template>
          <template v-slot:content><span v-html="item.body"></span></template>
        </Accordion>
      </div>
      </div>

    <!-- <p>{{this.includeContentInReviewAnswers}}</p>
    <p>{{this.statementContent}}</p>
    <pre>{{this.stepData.content}}</pre> -->
  </section>
</template>

<script>
import { dataService } from "../shared";

export default {
  name: "Statement",

  data() {
    return {
      id: "",
      sectionId: null,
      stepData: null,
      stepType: null,
      stepTitleVisible: null,
      title: "",
      bodyContent: "",
      topSections: null,
      bottomSections: null,
      topSectionOpenOnLoad: false,
      bottomSectionOpenOnLoad: false,
      includeContentInReviewAnswers: false,
      statementContent: null,
      nextUrl: "",
    };
  },

  created() {
    this.loadQuestion();
    if (this.includeContentInReviewAnswers) {
      this.logContent(this.statementContent);
    }
  },

  methods: {
    scrollToTopOfQAB() {
      document
        .getElementById("app-container")
        .scrollIntoView({ behavior: "smooth" }, true);
    },
    submitStatement() {
      this.$router.push({ name: this.nextUrl.toLowerCase() });
      this.scrollToTopOfQAB();
    },
    loadQuestion() {
      this.scrollToTopOfQAB();
      
      let json = dataService.getQuestions();
      let steps = json.steps;
      let currentStep = dataService.findElement(steps, dataService.parseUrl());
      let topContentSections = currentStep.content.topContentSections;
      let bottomContentSections = currentStep.content.bottomContentSections;

      this.id = currentStep.id;
      this.stepData = currentStep;
      this.stepType = currentStep.type;
      this.sectionId = currentStep.sectionId;
      this.title = currentStep.title;
      this.titleVisible = currentStep.titleVisible;
      this.bodyContent = currentStep.content.body;
      this.topSections = topContentSections;
      this.bottomSections = bottomContentSections;
      this.includeContentInReviewAnswers = currentStep.includeContentInReviewAnswers;
      this.statementContent = currentStep.content;
      // this.nextUrl = currentStep.destination;

      currentStep.responses.forEach((element) => {
        this.nextUrl = element.path;
      });
    },

    logContent(content) {
      let response = {
        id: this.id,
        sectionId: this.sectionId -1,
        type: this.stepType,
        statementViewed: true,
        content: [],
      };

      response.content.push(content);
      dataService.logStatementContent(response);
    }

  },
};
</script>